var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"redeem"},[_c('redeem-flow',{attrs:{"offer":_vm.$route.params.offer}}),_c('illustration-mosaic')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }